import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=4ddce2a0&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=4ddce2a0&prod&scoped=true&lang=css"
import style1 from "./edit.vue?vue&type=style&index=1&id=4ddce2a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddce2a0",
  null
  
)

export default component.exports